var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('canvas',{ref:"canvas",attrs:{"width":"600","height":"400"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.legend)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }